import { DatePicker } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { BsDownload } from "react-icons/bs";
import { Link, useSearchParams } from "react-router-dom";
import { get_auditory } from "../../../../api/endpoints/auditory";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../utils/notificationToast";
import Main from "../../../layout/main/Main";
import {
	AntdButton,
	AuditCard,
	ClientBox,
	ContentCard,
	FieldGroup,
	FieldLabel,
	FilterContainer,
	FilterGrid,
	Inner,
	PageTitle,
	PageWrapper,
	SectionTitle,
} from "./styles";

export default function LaboratoryAuditory({ clientId }) {
	const [searchParams] = useSearchParams();
	const uri = searchParams.get("uri");
	const [selectedMonth, setSelectedMonth] = useState(null);
	const [selectedQuarter, setSelectedQuarter] = useState(null);
	const [isLoadingMonthly, setIsLoadingMonthly] = useState(false);
	const [isLoadingAnnual, setIsLoadingAnnual] = useState(false);

	const handleSubmit = async () => {
		if (!selectedMonth) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Falta elegir un mes",
				"Elija un mes para poder descargar la auditoría mensual.",
			);
			return;
		}

		setIsLoadingMonthly(true);
		try {
			const data = {
				month: moment(selectedMonth).month() + 1,
				year: moment(selectedMonth).year(),
				quarter: 0,
				client: clientId,
			};

			const res = await get_auditory(
				data.month,
				data.year,
				data.quarter,
				data.client,
			);

			const href = URL.createObjectURL(res);
			const link = document.createElement("a");
			link.href = href;

			const fileName =
				"Auditory_" +
				"Month_" +
				data.month +
				"_Year_" +
				data.year +
				"_" +
				moment().format("DDMMYYYYhhmmss") +
				".xlsx";

			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoadingMonthly(false);
		}
	};

	const handleDownloadYear = async () => {
		if (!selectedQuarter) {
			openNotificationWithIcon(
				TYPE.ERROR,
				"Falta elegir un año/trimestre",
				"Elija un período para poder descargar la auditoría anual.",
			);
			return;
		}

		setIsLoadingAnnual(true);
		try {
			const data = {
				month: 0,
				year: moment(selectedQuarter).year(),
				quarter: moment(selectedQuarter).quarter(),
				client: clientId,
			};

			const res = await get_auditory(
				data.month,
				data.year,
				data.quarter,
				data.client,
			);

			const href = URL.createObjectURL(res);
			const link = document.createElement("a");
			link.href = href;

			const fileName =
				"Auditory_" +
				"Year_" +
				data.year +
				"_Quarter_" +
				data.quarter +
				"_" +
				moment().format("DDMMYYYYhhmmss") +
				".xlsx";

			link.setAttribute("download", fileName);
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			URL.revokeObjectURL(href);
		} catch (err) {
			console.log(err);
		} finally {
			setIsLoadingAnnual(false);
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						{uri ? (
							<Link to={"/" + uri}>Configuración General</Link>
						) : (
							<Link to="/">Home</Link>
						)}
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Auditoria</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				<PageWrapper>
					<ContentCard>
						<PageTitle>Gestión de Auditorías</PageTitle>

						<Inner>
							<AuditCard>
								<SectionTitle>Auditoría Mensual</SectionTitle>

								<FilterGrid>
									<FieldGroup>
										<FieldLabel>Seleccionar Mes</FieldLabel>
										<FilterContainer>
											<DatePicker.MonthPicker
												value={selectedMonth}
												onChange={(e) => setSelectedMonth(e)}
												placeholder="Seleccionar mes"
												format="MMMM YYYY"
											/>
										</FilterContainer>
									</FieldGroup>
									<FieldGroup>
										<AntdButton
											onClick={handleSubmit}
											loading={isLoadingMonthly}
										>
											<BsDownload />
											Descargar Auditoría Mensual
										</AntdButton>
									</FieldGroup>
								</FilterGrid>
							</AuditCard>

							<AuditCard>
								<SectionTitle>Auditoría Trimestral</SectionTitle>

								<FilterGrid>
									<FieldGroup>
										<FieldLabel>Seleccionar Trimestre</FieldLabel>
										<FilterContainer>
											<DatePicker.QuarterPicker
												value={selectedQuarter}
												onChange={(e) => setSelectedQuarter(e)}
												placeholder="Seleccionar trimestre"
												picker="quarter"
												format="[Q]Q YYYY"
											/>
										</FilterContainer>
									</FieldGroup>
									<FieldGroup>
										<AntdButton
											onClick={handleDownloadYear}
											loading={isLoadingAnnual}
										>
											<BsDownload />
											Descargar Auditoría Trimestral
										</AntdButton>
									</FieldGroup>
								</FilterGrid>
							</AuditCard>
						</Inner>
					</ContentCard>
				</PageWrapper>
			</Main.Body>
		</Main>
	);
}
